export function isUriseOnlyUser(user) {
  return Array.isArray(user?.roles) && user.roles.includes("urise_only");
}

// Called for authenticated Urise-only users, after the router's MFA check.
export function getUriseOnlyRedirect(route, needsTwoFactor = false) {
  const securityRoutes = ["TwoFactor", "MultiFactorAuthentication", "logout"];
  if (needsTwoFactor && !securityRoutes.includes(route.name)) {
    return "/2fa";
  }

  if (
    securityRoutes.includes(route.name) ||
    route.name === "UserDashboard" ||
    route.name === "Permalink" ||
    (route.name === "Documentation" &&
      ["privacy", "terms"].includes(route.params?.type))
  ) {
    return null;
  }

  return { path: "/dashboard", query: { tab: "wellness" }, replace: true };
}
